import bs58 from 'bs58';
import { Buffer } from 'buffer'; // 👈 make sure this is imported

// Encode MongoDB ObjectId -> short base58 string
export const encodeId = (id) => {
  try {
    if (!id || id.length !== 24) return id; // not a valid ObjectId
    return bs58.encode(Buffer.from(id, 'hex'));
  } catch (err) {
    console.error('Encoding failed:', err);
    return id;
  }
};

// Decode short base58 string -> MongoDB ObjectId
export const decodeId = (shortId) => {
  try {
    return Buffer.from(bs58.decode(shortId)).toString('hex');
  } catch (err) {
    console.error('Decoding failed:', err);
    return shortId;
  }
};
